import {
    IgMedia,
    IgMetadataAge,
    IgMetadataColor,
    IgMetadataEmotion,
    IgMetadataFaceDetail,
    IgMetadataGender,
    IgMetadataHashtag,
    IgUser,
} from '@core/models/ApiFields/ig-entities';
import { FILTER_TYPES } from '@features/social-analysis/models/IFilters';

export const socUsersFiltDims = [
    {
        category: 'Dimension',
        values: [
            {
                display: 'User',
                value: IgUser.getPrefixed('username'),
                type: FILTER_TYPES.COMBO,
            },
            {
                display: 'User influencer',
                value: IgUser.getPrefixed('influencer'),
                type: FILTER_TYPES.COMBO,
            },
            {
                display: 'Age',
                value: IgMetadataAge.getPrefixed('age'),
                type: FILTER_TYPES.COMBO,
            },
            {
                display: 'Color',
                value: IgMetadataColor.getPrefixed('color'),
                type: FILTER_TYPES.COMBO,
            },
            {
                display: 'Content type',
                value: IgMedia.getPrefixed('contentType'),
                type: FILTER_TYPES.COMBO,
            },
            {
                display: 'Emotion',
                value: IgMetadataEmotion.getPrefixed('emotion'),
                type: FILTER_TYPES.COMBO,
            },
            {
                display: 'Face detail',
                value: IgMetadataFaceDetail.getPrefixed('faceDetail'),
                type: FILTER_TYPES.COMBO,
            },
            {
                display: 'Gender',
                value: IgMetadataGender.getPrefixed('gender'),
                type: FILTER_TYPES.COMBO,
            },
            {
                display: 'Hashtag',
                value: IgMetadataHashtag.getPrefixed('hashtag'),
                type: FILTER_TYPES.COMBO,
            },
        ],
    },
    {
        category: 'Metric',
        values: [
            {
                display: 'User followers',
                value: IgUser.getPrefixed('followers'),
                type: FILTER_TYPES.NUMBER,
            },
            {
                display: 'User interactions',
                value: IgUser.getPrefixed('interactions'),
                type: FILTER_TYPES.NUMBER,
            },
            {
                display: 'User tags',
                value: IgUser.getPrefixed('tagsCount'),
                type: FILTER_TYPES.NUMBER,
            },
            {
                display: 'User posts',
                value: IgUser.getPrefixed('mediaCount'),
                type: FILTER_TYPES.NUMBER,
            },
            {
                display: 'User comments',
                value: IgUser.getPrefixed('commentsCount'),
                type: FILTER_TYPES.NUMBER,
            },
            {
                display: 'User interactions positivity',
                value: IgUser.getPrefixed('interactionsPositivity'),
                type: FILTER_TYPES.NUMBER,
            },
            {
                display: 'User interactions negativity',
                value: IgUser.getPrefixed('interactionsNegativity'),
                type: FILTER_TYPES.NUMBER,
            },
            {
                display: 'Comments',
                value: IgMedia.getPrefixed('comments'),
                type: FILTER_TYPES.NUMBER,
            },
            {
                display: 'Comments negativity',
                value: IgMedia.getPrefixed('commentsNegativity'),
                type: FILTER_TYPES.NUMBER,
            },
            {
                display: 'Comments positivity',
                value: IgMedia.getPrefixed('commentsPositivity'),
                type: FILTER_TYPES.NUMBER,
            },
            {
                display: 'Engagement rate',
                value: IgMedia.getPrefixed('engagementRate'),
                type: FILTER_TYPES.NUMBER,
            },
            {
                display: 'Followers from media',
                value: IgMedia.getPrefixed('followers'),
                type: FILTER_TYPES.NUMBER,
            },
            {
                display: 'Impressions',
                value: IgMedia.getPrefixed('impressions'),
                type: FILTER_TYPES.NUMBER,
            },
            {
                display: 'Interactions from media',
                value: IgMedia.getPrefixed('interactions'),
                type: FILTER_TYPES.NUMBER,
            },
            {
                display: 'Likes',
                value: IgMedia.getPrefixed('likes'),
                type: FILTER_TYPES.NUMBER,
            },
            {
                display: 'Media count',
                value: IgMedia.getPrefixed('mediaCount'),
                type: FILTER_TYPES.NUMBER,
            },
            {
                display: 'Negative comments',
                value: IgUser.getPrefixed('negativeComments'),
                type: FILTER_TYPES.NUMBER,
            },
            {
                display: 'Positive comments',
                value: IgUser.getPrefixed('positiveComments'),
                type: FILTER_TYPES.NUMBER,
            },
            {
                display: 'Profile activity from media',
                value: IgMedia.getPrefixed('profileActivity'),
                type: FILTER_TYPES.NUMBER,
            },
            {
                display: 'Profile activity on bio from media',
                value: IgMedia.getPrefixed('profileActivityBio'),
                type: FILTER_TYPES.NUMBER,
            },
            {
                display: 'Profile call action button from media',
                value: IgMedia.getPrefixed('profileActivityCall'),
                type: FILTER_TYPES.NUMBER,
            },
            {
                display: 'Profile direction action button from media',
                value: IgMedia.getPrefixed('profileActivityDirection'),
                type: FILTER_TYPES.NUMBER,
            },
            {
                display: 'Profile email action button from media',
                value: IgMedia.getPrefixed('profileActivityEmail'),
                type: FILTER_TYPES.NUMBER,
            },
            {
                display: 'Profile other activity from media',
                value: IgMedia.getPrefixed('profileActivityOther'),
                type: FILTER_TYPES.NUMBER,
            },
            {
                display: 'Profile text action button from media',
                value: IgMedia.getPrefixed('profileActivityText'),
                type: FILTER_TYPES.NUMBER,
            },
            {
                display: 'Profile visits from media',
                value: IgMedia.getPrefixed('profileViews'),
                type: FILTER_TYPES.NUMBER,
            },
            {
                display: 'Reach',
                value: IgMedia.getPrefixed('reach'),
                type: FILTER_TYPES.NUMBER,
            },
            {
                display: 'Saves',
                value: IgMedia.getPrefixed('saves'),
                type: FILTER_TYPES.NUMBER,
            },
            {
                display: 'Shares',
                value: IgMedia.getPrefixed('shares'),
                type: FILTER_TYPES.NUMBER,
            },
            {
                display: 'Stories navigation actions',
                value: IgMedia.getPrefixed('navigation'),
                type: FILTER_TYPES.NUMBER,
            },
            {
                display: 'Stories swipe back action',
                value: IgMedia.getPrefixed('navigationSwipeBack'),
                type: FILTER_TYPES.NUMBER,
            },
            {
                display: 'Stories tap back action',
                value: IgMedia.getPrefixed('navigationTapBack'),
                type: FILTER_TYPES.NUMBER,
            },
            {
                display: 'Stories tap exit action',
                value: IgMedia.getPrefixed('navigationTapExit'),
                type: FILTER_TYPES.NUMBER,
            },
            {
                display: 'Stories tap forward action',
                value: IgMedia.getPrefixed('navigationTapForward'),
                type: FILTER_TYPES.NUMBER,
            },
            {
                display: 'Video average watch time',
                value: IgMedia.getPrefixed('avgWatchTime'),
                type: FILTER_TYPES.NUMBER,
            },
            {
                display: 'Video plays',
                value: IgMedia.getPrefixed('plays'),
                type: FILTER_TYPES.NUMBER,
            },
            {
                display: 'Video view total time',
                value: IgMedia.getPrefixed('viewTotalTime'),
                type: FILTER_TYPES.NUMBER,
            },
        ],
    },
];
